// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InfoBlock__container-b2dc2a {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  margin: 0 auto;
  overflow: auto;
  position: relative;
  --info-block-text-color: var(--pattern-accent-0);
}

.InfoBlock__type-chat-with-pattern-cfb94e {
  --info-block-text-color: var(--pattern-accent);
}

.InfoBlock__type-page-b3370f {
  max-width: 360px;
}

.InfoBlock__type-chat-e92e8d,
.InfoBlock__type-chat-with-pattern-cfb94e {
  box-sizing: border-box;
  border-radius: 16px;
  flex: 0 0 auto;
  margin: auto;
  padding: 24px;
  max-width: 312px;
  min-width: 312px;
}

.InfoBlock__type-chat-with-pattern-cfb94e {
  background-color: var(--pattern-accent-base);
}

.InfoBlock__type-modal-a56376,
.InfoBlock__type-sidebar-f1ccdb {
  max-width: 288px;
}

.InfoBlock__image-fde310 {
  margin-bottom: 24px;
}

.InfoBlock__type-page-b3370f .InfoBlock__image-fde310 {
  height: 176px;
  max-width: 360px;
}

.InfoBlock__type-chat-e92e8d .InfoBlock__image-fde310,
.InfoBlock__type-chat-with-pattern-cfb94e .InfoBlock__image-fde310 {
  height: 144px;
  max-width: 264px;
}

.InfoBlock__type-modal-a56376 .InfoBlock__image-fde310,
.InfoBlock__type-sidebar-f1ccdb .InfoBlock__image-fde310 {
  height: 138px;
  max-width: 288px;
}

.InfoBlock__title-eb7d34 {
  font: var(--font-title-8);
  letter-spacing: var(--font-spacing-title-8);
  color: var(--info-block-text-color);
  text-align: center;
  margin-bottom: 4px;
}

.InfoBlock__type-page-b3370f .InfoBlock__title-eb7d34 {
  font: var(--font-title-6);
  letter-spacing: var(--font-spacing-title-6);
}

.InfoBlock__description-b20189 {
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-5);
  color: var(--info-block-text-color);
  text-align: center;
}

.InfoBlock__button-c98f70 {
  min-width: 180px;
  margin-top: 16px;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/InfoBlock/InfoBlock.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,OAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EAEA,gDAAA;AAAF;;AAGA;EACE,8CAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;;EAEE,sBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,4CAAA;AAAF;;AAGA;;EAEE,gBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,gBAAA;AAAF;;AAGA;;EAEE,aAAA;EACA,gBAAA;AAAF;;AAGA;;EAEE,aAAA;EACA,gBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,2CAAA;EACA,mCAAA;EACA,kBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,2CAAA;AAAF;;AAGA;EACE,wBAAA;EACA,0CAAA;EACA,mCAAA;EACA,kBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,gBAAA;AAAF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  margin: 0 auto;\n  overflow: auto;\n  position: relative;\n\n  --info-block-text-color: var(--pattern-accent-0);\n}\n\n.type-chat-with-pattern {\n  --info-block-text-color: var(--pattern-accent);\n}\n\n.type-page {\n  max-width: 360px;\n}\n\n.type-chat,\n.type-chat-with-pattern {\n  box-sizing: border-box;\n  border-radius: 16px;\n  flex: 0 0 auto;\n  margin: auto;\n  padding: 24px;\n  max-width: 312px;\n  min-width: 312px;\n}\n\n.type-chat-with-pattern {\n  background-color: var(--pattern-accent-base);\n}\n\n.type-modal,\n.type-sidebar {\n  max-width: 288px;\n}\n\n.image {\n  margin-bottom: 24px;\n}\n\n.type-page .image {\n  height: 176px;\n  max-width: 360px;\n}\n\n.type-chat .image,\n.type-chat-with-pattern .image {\n  height: 144px;\n  max-width: 264px;\n}\n\n.type-modal .image,\n.type-sidebar .image {\n  height: 138px;\n  max-width: 288px;\n}\n\n.title {\n  font: var(--font-title-8);\n  letter-spacing: var(--font-spacing-title-8);\n  color: var(--info-block-text-color);\n  text-align: center;\n  margin-bottom: 4px;\n}\n\n.type-page .title {\n  font: var(--font-title-6);\n  letter-spacing: var(--font-spacing-title-6);\n}\n\n.description {\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-5);\n  color: var(--info-block-text-color);\n  text-align: center;\n}\n\n.button {\n  min-width: 180px;\n  margin-top: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `InfoBlock__container-b2dc2a`,
	"type-chat-with-pattern": `InfoBlock__type-chat-with-pattern-cfb94e`,
	"typeChatWithPattern": `InfoBlock__type-chat-with-pattern-cfb94e`,
	"type-page": `InfoBlock__type-page-b3370f`,
	"typePage": `InfoBlock__type-page-b3370f`,
	"type-chat": `InfoBlock__type-chat-e92e8d`,
	"typeChat": `InfoBlock__type-chat-e92e8d`,
	"type-modal": `InfoBlock__type-modal-a56376`,
	"typeModal": `InfoBlock__type-modal-a56376`,
	"type-sidebar": `InfoBlock__type-sidebar-f1ccdb`,
	"typeSidebar": `InfoBlock__type-sidebar-f1ccdb`,
	"image": `InfoBlock__image-fde310`,
	"title": `InfoBlock__title-eb7d34`,
	"description": `InfoBlock__description-b20189`,
	"button": `InfoBlock__button-c98f70`
};
module.exports = ___CSS_LOADER_EXPORT___;
